module.exports = __webpack_public_path__ + "static/media/survey.76f6c24e.png";